import { styled } from "@tamagui/core";
import { focusableInputHOC } from "@tamagui/focusable";
import { textAreaSizeVariant } from "../helpers/inputHelpers";
import { InputFrame, defaultStyles } from "./Input";
const TextAreaFrame = styled(InputFrame, {
  name: "TextArea",
  multiline: true,
  variants: {
    unstyled: {
      false: {
        ...defaultStyles,
        height: "auto",
        numberOfLines: 4
      }
    },
    size: {
      "...size": textAreaSizeVariant
    }
  },
  defaultVariants: {
    unstyled: false
  }
});
const TextArea = focusableInputHOC(TextAreaFrame);
export {
  TextArea,
  TextAreaFrame
};
//# sourceMappingURL=TextArea.js.map
